module.exports = __webpack_public_path__ + "static/media/fast-and-simple.0df6878e.jpg";